// ClassicToolsMovedSeen — Classic 右の道具パネルで「画像貼付」ボタンが「道具 ▸」に置き換わったことを
// 知らせる印 (ボタンの小さな点) と、初回だけ出す「画像貼付はここに移りました」の seen フラグ
// (docs/_wip/region-move-2026-10-15.md「入口」)。
//
// 消える条件は「道具 ▸ の小窓を一度でも開いたら」。印とお知らせは同じ契機で片付くので 1 つの
// フラグで持つ。他の New! バッジ (`customCursorNewBadgeSeen.ts` 等) と同流儀: `'1'` を保存、
// 不在 / storage 不可 / 例外は「未 seen」(= 出す) に倒し、例外は握りつぶす。

export const CLASSIC_TOOLS_MOVED_SEEN_KEY = 'oekaki:classic-tools-moved-seen';

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

export interface ClassicToolsMovedSeenStore {
  hasSeen(): boolean;
  markSeen(): void;
  clear(): void;
}

const probeBrowserStorage = (): StorageLike | null => {
  try {
    const ls = globalThis.localStorage;
    if (!ls) return null;
    const sentinel = 'oekaki:classic-tools-moved-seen__probe__';
    ls.setItem(sentinel, '1');
    const got = ls.getItem(sentinel);
    ls.removeItem(sentinel);
    return got === '1' ? ls : null;
  } catch {
    return null;
  }
};

export const createClassicToolsMovedSeenStore = (
  opts: { storage?: StorageLike | null } = {},
): ClassicToolsMovedSeenStore => {
  const explicit = opts.storage;
  const storage = explicit === null ? null : (explicit ?? probeBrowserStorage());
  return {
    hasSeen() {
      if (storage === null) return false;
      try {
        return storage.getItem(CLASSIC_TOOLS_MOVED_SEEN_KEY) !== null;
      } catch {
        return false;
      }
    },
    markSeen() {
      if (storage === null) return;
      try {
        storage.setItem(CLASSIC_TOOLS_MOVED_SEEN_KEY, '1');
      } catch {
        // QuotaExceeded / SecurityError 等 — 出し直しになるだけで害はない。
      }
    },
    clear() {
      if (storage === null) return;
      try {
        storage.removeItem(CLASSIC_TOOLS_MOVED_SEEN_KEY);
      } catch {
        // ignore
      }
    },
  };
};
